module.exports = __webpack_public_path__ + "static/media/sodoto-page-title@3x.59151337.png";